// tslint:disable
/**
 * Agents API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddAgentNewsEntryCommand
 */
export interface AddAgentNewsEntryCommand {
    /**
     * 
     * @type {string}
     * @memberof AddAgentNewsEntryCommand
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddAgentNewsEntryCommand
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface AgentDto
 */
export interface AgentDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    status?: string | null;
}
/**
 * 
 * @export
 * @interface AgentLicenseDto
 */
export interface AgentLicenseDto {
    /**
     * 
     * @type {string}
     * @memberof AgentLicenseDto
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentLicenseDto
     */
    agentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentLicenseDto
     */
    managerNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentLicenseDto
     */
    managerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentLicenseDto
     */
    licenseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentLicenseDto
     */
    licenseState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentLicenseDto
     */
    status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AgentLicenseDto
     */
    effectiveDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AgentLicenseDto
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentLicenseDto
     */
    life?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentLicenseDto
     */
    deferredAnnuity?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentLicenseDto
     */
    additional?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentLicenseDto
     */
    disability?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentLicenseDto
     */
    medical?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentLicenseDto
     */
    universalLife?: boolean;
}
/**
 * 
 * @export
 * @interface AgentNewsDto
 */
export interface AgentNewsDto {
    /**
     * 
     * @type {string}
     * @memberof AgentNewsDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNewsDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNewsDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AgentNewsDto
     */
    publishDate?: Date;
}
/**
 * 
 * @export
 * @interface AgentNumberStatus
 */
export interface AgentNumberStatus extends Enumeration {
}
/**
 * 
 * @export
 * @interface AgentsHierarchyDto
 */
export interface AgentsHierarchyDto {
    /**
     * 
     * @type {HierarchyDto}
     * @memberof AgentsHierarchyDto
     */
    manager?: HierarchyDto | null;
    /**
     * 
     * @type {Array<HierarchyDto>}
     * @memberof AgentsHierarchyDto
     */
    levelOneEmployees?: Array<HierarchyDto> | null;
}
/**
 * 
 * @export
 * @interface Enumeration
 */
export interface Enumeration {
    /**
     * 
     * @type {string}
     * @memberof Enumeration
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Enumeration
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface HierarchyDto
 */
export interface HierarchyDto {
    /**
     * 
     * @type {string}
     * @memberof HierarchyDto
     */
    agentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HierarchyDto
     */
    agentName?: string | null;
    /**
     * 
     * @type {AgentNumberStatus}
     * @memberof HierarchyDto
     */
    status?: AgentNumberStatus | null;
    /**
     * 
     * @type {Link}
     * @memberof HierarchyDto
     */
    link?: Link | null;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfAgentDto
 */
export interface PagedResultOfAgentDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<AgentDto>}
     * @memberof PagedResultOfAgentDto
     */
    result?: Array<AgentDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfAgentDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfAgentLicenseDto
 */
export interface PagedResultOfAgentLicenseDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentLicenseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentLicenseDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<AgentLicenseDto>}
     * @memberof PagedResultOfAgentLicenseDto
     */
    result?: Array<AgentLicenseDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfAgentLicenseDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfAgentNewsDto
 */
export interface PagedResultOfAgentNewsDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentNewsDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentNewsDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<AgentNewsDto>}
     * @memberof PagedResultOfAgentNewsDto
     */
    result?: Array<AgentNewsDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfAgentNewsDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface ProcessLogDto
 */
export interface ProcessLogDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    processName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    machineName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadStartDateTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadEndDateTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    elapsedTime?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAgentCommand
 */
export interface UpdateAgentCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentCommand
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentCommand
     */
    username?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAgentNewsEntryCommand
 */
export interface UpdateAgentNewsEntryCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentNewsEntryCommand
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentNewsEntryCommand
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentNewsEntryCommand
     */
    description?: string | null;
}

/**
 * AgentLicensesApi - axios parameter creator
 * @export
 */
export const AgentLicensesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentLicensesAgentLicensesResetETL(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentLicensesAgentLicensesResetETL.');
            }
            const localVarPath = `/api/v{version}/agents/licenses/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentLicenses(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchAgentLicenses.');
            }
            const localVarPath = `/api/v{version}/agents/licenses`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentLicensesApi - functional programming interface
 * @export
 */
export const AgentLicensesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentLicensesAgentLicensesResetETL(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AgentLicensesApiAxiosParamCreator(configuration).agentLicensesAgentLicensesResetETL(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentLicenses(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfAgentLicenseDto> {
            const localVarAxiosArgs = AgentLicensesApiAxiosParamCreator(configuration).searchAgentLicenses(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentLicensesApi - factory interface
 * @export
 */
export const AgentLicensesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentLicensesAgentLicensesResetETL(version: string, options?: any): AxiosPromise<void> {
            return AgentLicensesApiFp(configuration).agentLicensesAgentLicensesResetETL(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentLicenses(version: string, options?: any): AxiosPromise<PagedResultOfAgentLicenseDto> {
            return AgentLicensesApiFp(configuration).searchAgentLicenses(version, options)(axios, basePath);
        },
    };
};

/**
 * AgentLicensesApi - object-oriented interface
 * @export
 * @class AgentLicensesApi
 * @extends {BaseAPI}
 */
export class AgentLicensesApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentLicensesApi
     */
    public agentLicensesAgentLicensesResetETL(version: string, options?: any) {
        return AgentLicensesApiFp(this.configuration).agentLicensesAgentLicensesResetETL(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentLicensesApi
     */
    public searchAgentLicenses(version: string, options?: any) {
        return AgentLicensesApiFp(this.configuration).searchAgentLicenses(version, options)(this.axios, this.basePath);
    }

}


/**
 * AgentNewsApi - axios parameter creator
 * @export
 */
export const AgentNewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddAgentNewsEntryCommand} addAgentNewsEntryCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsAdd(version: string, addAgentNewsEntryCommand: AddAgentNewsEntryCommand, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNewsAdd.');
            }
            // verify required parameter 'addAgentNewsEntryCommand' is not null or undefined
            if (addAgentNewsEntryCommand === null || addAgentNewsEntryCommand === undefined) {
                throw new RequiredError('addAgentNewsEntryCommand','Required parameter addAgentNewsEntryCommand was null or undefined when calling agentNewsAdd.');
            }
            const localVarPath = `/api/v{version}/agents/news`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof addAgentNewsEntryCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addAgentNewsEntryCommand !== undefined ? addAgentNewsEntryCommand : {}) : (addAgentNewsEntryCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsDelete(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agentNewsDelete.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNewsDelete.');
            }
            const localVarPath = `/api/v{version}/agents/news/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsGet(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agentNewsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNewsGet.');
            }
            const localVarPath = `/api/v{version}/agents/news/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAgentNewsEntryCommand} updateAgentNewsEntryCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsUpdate(version: string, updateAgentNewsEntryCommand: UpdateAgentNewsEntryCommand, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNewsUpdate.');
            }
            // verify required parameter 'updateAgentNewsEntryCommand' is not null or undefined
            if (updateAgentNewsEntryCommand === null || updateAgentNewsEntryCommand === undefined) {
                throw new RequiredError('updateAgentNewsEntryCommand','Required parameter updateAgentNewsEntryCommand was null or undefined when calling agentNewsUpdate.');
            }
            const localVarPath = `/api/v{version}/agents/news`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof updateAgentNewsEntryCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAgentNewsEntryCommand !== undefined ? updateAgentNewsEntryCommand : {}) : (updateAgentNewsEntryCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentNews(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchAgentNews.');
            }
            const localVarPath = `/api/v{version}/agents/news`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentNewsApi - functional programming interface
 * @export
 */
export const AgentNewsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddAgentNewsEntryCommand} addAgentNewsEntryCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsAdd(version: string, addAgentNewsEntryCommand: AddAgentNewsEntryCommand, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentNewsDto> {
            const localVarAxiosArgs = AgentNewsApiAxiosParamCreator(configuration).agentNewsAdd(version, addAgentNewsEntryCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsDelete(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentNewsDto> {
            const localVarAxiosArgs = AgentNewsApiAxiosParamCreator(configuration).agentNewsDelete(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsGet(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentNewsDto> {
            const localVarAxiosArgs = AgentNewsApiAxiosParamCreator(configuration).agentNewsGet(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAgentNewsEntryCommand} updateAgentNewsEntryCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsUpdate(version: string, updateAgentNewsEntryCommand: UpdateAgentNewsEntryCommand, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentNewsDto> {
            const localVarAxiosArgs = AgentNewsApiAxiosParamCreator(configuration).agentNewsUpdate(version, updateAgentNewsEntryCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentNews(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfAgentNewsDto> {
            const localVarAxiosArgs = AgentNewsApiAxiosParamCreator(configuration).searchAgentNews(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentNewsApi - factory interface
 * @export
 */
export const AgentNewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddAgentNewsEntryCommand} addAgentNewsEntryCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsAdd(version: string, addAgentNewsEntryCommand: AddAgentNewsEntryCommand, options?: any): AxiosPromise<AgentNewsDto> {
            return AgentNewsApiFp(configuration).agentNewsAdd(version, addAgentNewsEntryCommand, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsDelete(id: string, version: string, options?: any): AxiosPromise<AgentNewsDto> {
            return AgentNewsApiFp(configuration).agentNewsDelete(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsGet(id: string, version: string, options?: any): AxiosPromise<AgentNewsDto> {
            return AgentNewsApiFp(configuration).agentNewsGet(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAgentNewsEntryCommand} updateAgentNewsEntryCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNewsUpdate(version: string, updateAgentNewsEntryCommand: UpdateAgentNewsEntryCommand, options?: any): AxiosPromise<AgentNewsDto> {
            return AgentNewsApiFp(configuration).agentNewsUpdate(version, updateAgentNewsEntryCommand, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentNews(version: string, options?: any): AxiosPromise<PagedResultOfAgentNewsDto> {
            return AgentNewsApiFp(configuration).searchAgentNews(version, options)(axios, basePath);
        },
    };
};

/**
 * AgentNewsApi - object-oriented interface
 * @export
 * @class AgentNewsApi
 * @extends {BaseAPI}
 */
export class AgentNewsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {AddAgentNewsEntryCommand} addAgentNewsEntryCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNewsApi
     */
    public agentNewsAdd(version: string, addAgentNewsEntryCommand: AddAgentNewsEntryCommand, options?: any) {
        return AgentNewsApiFp(this.configuration).agentNewsAdd(version, addAgentNewsEntryCommand, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNewsApi
     */
    public agentNewsDelete(id: string, version: string, options?: any) {
        return AgentNewsApiFp(this.configuration).agentNewsDelete(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNewsApi
     */
    public agentNewsGet(id: string, version: string, options?: any) {
        return AgentNewsApiFp(this.configuration).agentNewsGet(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {UpdateAgentNewsEntryCommand} updateAgentNewsEntryCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNewsApi
     */
    public agentNewsUpdate(version: string, updateAgentNewsEntryCommand: UpdateAgentNewsEntryCommand, options?: any) {
        return AgentNewsApiFp(this.configuration).agentNewsUpdate(version, updateAgentNewsEntryCommand, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNewsApi
     */
    public searchAgentNews(version: string, options?: any) {
        return AgentNewsApiFp(this.configuration).searchAgentNews(version, options)(this.axios, this.basePath);
    }

}


/**
 * AgentsApi - axios parameter creator
 * @export
 */
export const AgentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGenerateEmailLink(version: string, agentId?: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentsGenerateEmailLink.');
            }
            const localVarPath = `/api/v{version}/agents/emailLink`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGetAgentByKey(key: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling agentsGetAgentByKey.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentsGetAgentByKey.');
            }
            const localVarPath = `/api/v{version}/agents/key/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGetByUserId(userName: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new RequiredError('userName','Required parameter userName was null or undefined when calling agentsGetByUserId.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentsGetByUserId.');
            }
            const localVarPath = `/api/v{version}/agents/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAgentCommand} updateAgentCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsUpdateUsername(version: string, updateAgentCommand: UpdateAgentCommand, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentsUpdateUsername.');
            }
            // verify required parameter 'updateAgentCommand' is not null or undefined
            if (updateAgentCommand === null || updateAgentCommand === undefined) {
                throw new RequiredError('updateAgentCommand','Required parameter updateAgentCommand was null or undefined when calling agentsUpdateUsername.');
            }
            const localVarPath = `/api/v{version}/agents/updateUsername`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof updateAgentCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAgentCommand !== undefined ? updateAgentCommand : {}) : (updateAgentCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgents(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchAgents.');
            }
            const localVarPath = `/api/v{version}/agents`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentsApi - functional programming interface
 * @export
 */
export const AgentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGenerateEmailLink(version: string, agentId?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AgentsApiAxiosParamCreator(configuration).agentsGenerateEmailLink(version, agentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGetAgentByKey(key: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AgentsApiAxiosParamCreator(configuration).agentsGetAgentByKey(key, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGetByUserId(userName: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AgentsApiAxiosParamCreator(configuration).agentsGetByUserId(userName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAgentCommand} updateAgentCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsUpdateUsername(version: string, updateAgentCommand: UpdateAgentCommand, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AgentsApiAxiosParamCreator(configuration).agentsUpdateUsername(version, updateAgentCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgents(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfAgentDto> {
            const localVarAxiosArgs = AgentsApiAxiosParamCreator(configuration).searchAgents(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentsApi - factory interface
 * @export
 */
export const AgentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGenerateEmailLink(version: string, agentId?: string, options?: any): AxiosPromise<any> {
            return AgentsApiFp(configuration).agentsGenerateEmailLink(version, agentId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGetAgentByKey(key: string, version: string, options?: any): AxiosPromise<any> {
            return AgentsApiFp(configuration).agentsGetAgentByKey(key, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGetByUserId(userName: string, version: string, options?: any): AxiosPromise<any> {
            return AgentsApiFp(configuration).agentsGetByUserId(userName, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {UpdateAgentCommand} updateAgentCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsUpdateUsername(version: string, updateAgentCommand: UpdateAgentCommand, options?: any): AxiosPromise<any> {
            return AgentsApiFp(configuration).agentsUpdateUsername(version, updateAgentCommand, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgents(version: string, options?: any): AxiosPromise<PagedResultOfAgentDto> {
            return AgentsApiFp(configuration).searchAgents(version, options)(axios, basePath);
        },
    };
};

/**
 * AgentsApi - object-oriented interface
 * @export
 * @class AgentsApi
 * @extends {BaseAPI}
 */
export class AgentsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [agentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public agentsGenerateEmailLink(version: string, agentId?: string, options?: any) {
        return AgentsApiFp(this.configuration).agentsGenerateEmailLink(version, agentId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} key 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public agentsGetAgentByKey(key: string, version: string, options?: any) {
        return AgentsApiFp(this.configuration).agentsGetAgentByKey(key, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} userName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public agentsGetByUserId(userName: string, version: string, options?: any) {
        return AgentsApiFp(this.configuration).agentsGetByUserId(userName, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {UpdateAgentCommand} updateAgentCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public agentsUpdateUsername(version: string, updateAgentCommand: UpdateAgentCommand, options?: any) {
        return AgentsApiFp(this.configuration).agentsUpdateUsername(version, updateAgentCommand, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    public searchAgents(version: string, options?: any) {
        return AgentsApiFp(this.configuration).searchAgents(version, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling documentsGet.');
            }
            const localVarPath = `/api/v{version}/agents/documents/contactus`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).documentsGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGet(version: string, options?: any): AxiosPromise<string> {
            return DocumentsApiFp(configuration).documentsGet(version, options)(axios, basePath);
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public documentsGet(version: string, options?: any) {
        return DocumentsApiFp(this.configuration).documentsGet(version, options)(this.axios, this.basePath);
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/v{version}/agents/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options)(axios, basePath);
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options)(this.axios, this.basePath);
    }

}


/**
 * HierarchyApi - axios parameter creator
 * @export
 */
export const HierarchyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} agentNumber 
         * @param {string} version 
         * @param {boolean} [isNewYork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsHierarchy(agentNumber: string, version: string, isNewYork?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'agentNumber' is not null or undefined
            if (agentNumber === null || agentNumber === undefined) {
                throw new RequiredError('agentNumber','Required parameter agentNumber was null or undefined when calling getAgentsHierarchy.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getAgentsHierarchy.');
            }
            const localVarPath = `/api/v{version}/agents/{agentNumber}/hierarchy`
                .replace(`{${"agentNumber"}}`, encodeURIComponent(String(agentNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (isNewYork !== undefined) {
                localVarQueryParameter['isNewYork'] = isNewYork;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlatHierarchy(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getFlatHierarchy.');
            }
            const localVarPath = `/api/v{version}/agents/hierarchy`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hierarchyHierarchyETL(version: string, sourceId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling hierarchyHierarchyETL.');
            }
            const localVarPath = `/api/v{version}/agents/hierarchy/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HierarchyApi - functional programming interface
 * @export
 */
export const HierarchyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} agentNumber 
         * @param {string} version 
         * @param {boolean} [isNewYork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsHierarchy(agentNumber: string, version: string, isNewYork?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentsHierarchyDto> {
            const localVarAxiosArgs = HierarchyApiAxiosParamCreator(configuration).getAgentsHierarchy(agentNumber, version, isNewYork, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlatHierarchy(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>> {
            const localVarAxiosArgs = HierarchyApiAxiosParamCreator(configuration).getFlatHierarchy(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hierarchyHierarchyETL(version: string, sourceId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = HierarchyApiAxiosParamCreator(configuration).hierarchyHierarchyETL(version, sourceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HierarchyApi - factory interface
 * @export
 */
export const HierarchyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} agentNumber 
         * @param {string} version 
         * @param {boolean} [isNewYork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsHierarchy(agentNumber: string, version: string, isNewYork?: boolean, options?: any): AxiosPromise<AgentsHierarchyDto> {
            return HierarchyApiFp(configuration).getAgentsHierarchy(agentNumber, version, isNewYork, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlatHierarchy(version: string, options?: any): AxiosPromise<Array<string>> {
            return HierarchyApiFp(configuration).getFlatHierarchy(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hierarchyHierarchyETL(version: string, sourceId?: number, options?: any): AxiosPromise<void> {
            return HierarchyApiFp(configuration).hierarchyHierarchyETL(version, sourceId, options)(axios, basePath);
        },
    };
};

/**
 * HierarchyApi - object-oriented interface
 * @export
 * @class HierarchyApi
 * @extends {BaseAPI}
 */
export class HierarchyApi extends BaseAPI {
    /**
     * 
     * @param {string} agentNumber 
     * @param {string} version 
     * @param {boolean} [isNewYork] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyApi
     */
    public getAgentsHierarchy(agentNumber: string, version: string, isNewYork?: boolean, options?: any) {
        return HierarchyApiFp(this.configuration).getAgentsHierarchy(agentNumber, version, isNewYork, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyApi
     */
    public getFlatHierarchy(version: string, options?: any) {
        return HierarchyApiFp(this.configuration).getFlatHierarchy(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {number} [sourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyApi
     */
    public hierarchyHierarchyETL(version: string, sourceId?: number, options?: any) {
        return HierarchyApiFp(this.configuration).hierarchyHierarchyETL(version, sourceId, options)(this.axios, this.basePath);
    }

}


/**
 * ProcessLogsApi - axios parameter creator
 * @export
 */
export const ProcessLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getLatestEtlStatuses.');
            }
            const localVarPath = `/api/v{version}/agents/processlogs/latest`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessLogsApi - functional programming interface
 * @export
 */
export const ProcessLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessLogDto>> {
            const localVarAxiosArgs = ProcessLogsApiAxiosParamCreator(configuration).getLatestEtlStatuses(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessLogsApi - factory interface
 * @export
 */
export const ProcessLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): AxiosPromise<Array<ProcessLogDto>> {
            return ProcessLogsApiFp(configuration).getLatestEtlStatuses(version, options)(axios, basePath);
        },
    };
};

/**
 * ProcessLogsApi - object-oriented interface
 * @export
 * @class ProcessLogsApi
 * @extends {BaseAPI}
 */
export class ProcessLogsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessLogsApi
     */
    public getLatestEtlStatuses(version: string, options?: any) {
        return ProcessLogsApiFp(this.configuration).getLatestEtlStatuses(version, options)(this.axios, this.basePath);
    }

}


/**
 * ProducerCompliancePolicyAttachmentsApi - axios parameter creator
 * @export
 */
export const ProducerCompliancePolicyAttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        producerCompliancePolicyAttachmentsGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling producerCompliancePolicyAttachmentsGet.');
            }
            const localVarPath = `/api/v{version}/agents/producerCompliancePolicyAttachments`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        producerCompliancePolicyAttachmentsGetFile(fileName: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling producerCompliancePolicyAttachmentsGetFile.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling producerCompliancePolicyAttachmentsGetFile.');
            }
            const localVarPath = `/api/v{version}/agents/producerCompliancePolicyAttachments/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProducerCompliancePolicyAttachmentsApi - functional programming interface
 * @export
 */
export const ProducerCompliancePolicyAttachmentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        producerCompliancePolicyAttachmentsGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Link>> {
            const localVarAxiosArgs = ProducerCompliancePolicyAttachmentsApiAxiosParamCreator(configuration).producerCompliancePolicyAttachmentsGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        producerCompliancePolicyAttachmentsGetFile(fileName: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ProducerCompliancePolicyAttachmentsApiAxiosParamCreator(configuration).producerCompliancePolicyAttachmentsGetFile(fileName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProducerCompliancePolicyAttachmentsApi - factory interface
 * @export
 */
export const ProducerCompliancePolicyAttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        producerCompliancePolicyAttachmentsGet(version: string, options?: any): AxiosPromise<Array<Link>> {
            return ProducerCompliancePolicyAttachmentsApiFp(configuration).producerCompliancePolicyAttachmentsGet(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        producerCompliancePolicyAttachmentsGetFile(fileName: string, version: string, options?: any): AxiosPromise<string> {
            return ProducerCompliancePolicyAttachmentsApiFp(configuration).producerCompliancePolicyAttachmentsGetFile(fileName, version, options)(axios, basePath);
        },
    };
};

/**
 * ProducerCompliancePolicyAttachmentsApi - object-oriented interface
 * @export
 * @class ProducerCompliancePolicyAttachmentsApi
 * @extends {BaseAPI}
 */
export class ProducerCompliancePolicyAttachmentsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProducerCompliancePolicyAttachmentsApi
     */
    public producerCompliancePolicyAttachmentsGet(version: string, options?: any) {
        return ProducerCompliancePolicyAttachmentsApiFp(this.configuration).producerCompliancePolicyAttachmentsGet(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} fileName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProducerCompliancePolicyAttachmentsApi
     */
    public producerCompliancePolicyAttachmentsGetFile(fileName: string, version: string, options?: any) {
        return ProducerCompliancePolicyAttachmentsApiFp(this.configuration).producerCompliancePolicyAttachmentsGetFile(fileName, version, options)(this.axios, this.basePath);
    }

}


/**
 * RateGeneratorApi - axios parameter creator
 * @export
 */
export const RateGeneratorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateGeneratorGetGenerator(fileName: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling rateGeneratorGetGenerator.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling rateGeneratorGetGenerator.');
            }
            const localVarPath = `/api/v{version}/agents/rategenerators/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateGeneratorGetRateGenerators(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling rateGeneratorGetRateGenerators.');
            }
            const localVarPath = `/api/v{version}/agents/rategenerators`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RateGeneratorApi - functional programming interface
 * @export
 */
export const RateGeneratorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateGeneratorGetGenerator(fileName: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = RateGeneratorApiAxiosParamCreator(configuration).rateGeneratorGetGenerator(fileName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateGeneratorGetRateGenerators(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Link>> {
            const localVarAxiosArgs = RateGeneratorApiAxiosParamCreator(configuration).rateGeneratorGetRateGenerators(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RateGeneratorApi - factory interface
 * @export
 */
export const RateGeneratorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateGeneratorGetGenerator(fileName: string, version: string, options?: any): AxiosPromise<string> {
            return RateGeneratorApiFp(configuration).rateGeneratorGetGenerator(fileName, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateGeneratorGetRateGenerators(version: string, options?: any): AxiosPromise<Array<Link>> {
            return RateGeneratorApiFp(configuration).rateGeneratorGetRateGenerators(version, options)(axios, basePath);
        },
    };
};

/**
 * RateGeneratorApi - object-oriented interface
 * @export
 * @class RateGeneratorApi
 * @extends {BaseAPI}
 */
export class RateGeneratorApi extends BaseAPI {
    /**
     * 
     * @param {string} fileName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateGeneratorApi
     */
    public rateGeneratorGetGenerator(fileName: string, version: string, options?: any) {
        return RateGeneratorApiFp(this.configuration).rateGeneratorGetGenerator(fileName, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateGeneratorApi
     */
    public rateGeneratorGetRateGenerators(version: string, options?: any) {
        return RateGeneratorApiFp(this.configuration).rateGeneratorGetRateGenerators(version, options)(this.axios, this.basePath);
    }

}


